import { ASSETS } from "assets";
import ErrorBox from "lib/components/common/error-box";
import FlexBox from "lib/components/common/flex-box";
import AuthenticationLayout from "lib/components/layouts/authentication";
import { Image } from "react-bootstrap";

const MaintenancePage = () => {
  return (
    <AuthenticationLayout>
      <FlexBox className="h-100" justifyContent="around">
        <Image
          src={ASSETS.IMAGES.LOGIN_IMAGE}
          alt="Maintenance"
          className="login-image"
        />
        <FlexBox direction="column" justifyContent="start" alignItems="start">
          <h1>The app is under maintenance.</h1>
          <ErrorBox
            message="We are updating our backend services. Please visit again in
            sometime."
          />
        </FlexBox>
      </FlexBox>
    </AuthenticationLayout>
  );
};

export default MaintenancePage;
